import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import GatewayForm from "./GeteayForm";
import { toast } from "react-toastify";

export default function Gateway() {
  const [data, setData] = useState(undefined);
  const [cookies, setCookie, removeCookie] = useCookies();

  useEffect(() => {
    getData();
  }, []);
  function getData() {
    const url = Constants.apiUrl + "/api/gateway/get";
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        setData(r.data);
      })
      .catch((e) => {});
  }
  function update(id, name, description, status) {
    const url = Constants.apiUrl + "/api/gateway/update";
    axios
      .post(
        url,
        {
          id: id,
          name: name,
          description: description,
          status: status,
        },
        {
          headers: {
            Authorization: "Bearer " + cookies.user_server_token,
          },
        }
      )
      .then((r) => {
        toast.success("تغییرات با موفقیت انجام شد");
        getData()
      })
      .catch((e) => {});
  }
  function store(id, name, description, status) {
    const url = Constants.apiUrl + "/api/gateway/store";
    axios
      .post(
        url,
        {
          name: name,
          description: description,
          status: status,
        },
        {
          headers: {
            Authorization: "Bearer " + cookies.user_server_token,
          },
        }
      )
      .then((r) => {
        toast.success("تغییرات با موفقیت انجام شد");
        getData()

      })
      .catch((e) => {});
  }
  return (
    <>
      <Breadcrumb title={"مدیریت درگاه پرداخت"} />
      <div className="container">
        <div className="row text-right">
          {data &&
            data.map((item) => (
              <div className="col-12 col-md-12 p-4 border rounded m-3">
                <h4>ویرایش</h4>
                <hr />
                <GatewayForm item={item} action={update} />
              </div>
            ))}
          <div className="col-12 col-md-12 p-4 border rounded m-3">
            <h4>افزودن</h4>
            <hr />
            <GatewayForm action={store} />
          </div>
        </div>
      </div>
    </>
  );
}
